$(document).ready(function () {
    $(document).on('click', '.block__cart-drawer-item-btn-qty', function () {
        let $this = $(this);
        let qty = parseInt($this.parent('.block__cart-drawer-item-qtybox').find('.block__cart-drawer-item-quantity-input').val());
        if ($this.hasClass('block__cart-drawer-item-qtyplus')) {
            qty++;
        } else {
            if (qty > 0) {
                qty--;
            }
        }
        qty = (isNaN(qty)) ? 0 : qty;
        $this.parent('.block__cart-drawer-item-qtybox').find('.block__cart-drawer-item-quantity-input').val(qty);
        let parentElement = $this.parents(".js-cart-drawer-item-box");
        let id = parentElement.attr("js-data-variant-id");
        CartItemChange(id, qty)
    });

    $(document).on("click",".js-art-drawer-item-remove",function(){
        let $this = $(this);
        let parentElement = $this.parents(".js-cart-drawer-item-box");
        let id = parentElement.attr("js-data-variant-id");
        let qty = 0;
        CartItemChange(id, qty)  
    });

    $(".js-cart-drawer-item-quantity-input").on("change",function(){
        let $this = $(this);
        let parentElement = $this.parents(".js-cart-drawer-item-box");
        let id = parentElement.attr("js-data-variant-id");
        let qty = $this.val();
        CartItemChange(id, qty)   
    });

    $(document).on("click",".js-header-cart-drawer",function(event){
        event.preventDefault();
        $(".js-cart-drawer-section").addClass("active");
        $(".js-cart-drawer-overlay").addClass("active");
        $("body").addClass("overflow-hidden");
    });

    $(document).on("click",".js-cart-drawer-close, .js-cart-drawer-overlay",function(event){
        event.preventDefault();
        $(".js-cart-drawer-section").removeClass("active");
        $(".js-cart-drawer-overlay").removeClass("active");
        $("body").removeClass("overflow-hidden");
    });

    $(document).on("click",".js-cart-drawer-item-detail-subscribe-btn",function(event){
        event.preventDefault();
        let $this = $(this);
        let parentElement = $this.parents(".js-cart-drawer-item-box");
        let id = parentElement.attr("js-data-variant-id");
        let newid = $this.attr("js-new-product-id");
        let qty = parentElement.attr("js-data-variant-qty");
        $(".js-cart-drawer-item-detail-subscribe-btn").attr('disabled',true);
        CartItemUpdate(id, newid, qty);
    });

    $(".js-cart-item-product-option").on("change",function(){
        let $this = $(this);
        $(".js-cart-item-product-option").prop('disabled', 'disabled');
        cartItemOptionUpdate($this);
    });

    function cartItemOptionUpdate($this){
        let selectedValue = $this.val();
        let data_index = $this.attr("data-index");
        let parentElement = $this.parents(".js-cart-drawer-item-box");
        let id = parentElement.attr("js-data-variant-id");
        let qty = parentElement.attr("js-data-variant-qty");

        let optionTwo_Array = [];
        let optionThree_Array = [];

        var selected_option_two = $(".js-cart-item-product-option-2").val();
        var selected_option_three = $(".js-cart-item-product-option-3").val();
        if(data_index == "options-1"){
            $this.parents(".block__cart-item-product-options-list").find(".variant_select option[data-option1='"+selectedValue+"']").each(function(){
                if($(this).attr("data-option2") != ''){
                    optionTwo_Array.push($(this).attr("data-option2"))
                } 
                if($(this).attr("data-option3") != ''){
                    let optionThreeselecteValue = $this.parents(".block__cart-item-product-options-list").find(".js-cart-item-product-option-2").val();
                    if(optionThreeselecteValue == $(this).attr("data-option2")){
                        optionThree_Array.push($(this).attr("data-option3"))
                    }
                } 
            });
        }

        if(data_index == "options-2"){
            $this.parents(".block__cart-item-product-options-list").find(".variant_select option[data-option2='"+selectedValue+"']").each(function(){
                if($(this).attr("data-option3") != ''){
                    let optionThreeselecteValue = $this.parents(".block__cart-item-product-options-list").find(".js-cart-item-product-option-2").val();
                    if(optionThreeselecteValue == $(this).attr("data-option2")){
                        optionThree_Array.push($(this).attr("data-option3"))
                    }
                } 
            });
        }


        if(optionTwo_Array.length > 0){
            var uniqueOptionTwo_Array = [...new Set(optionTwo_Array)];
            let optionTwoOptiones;
            $(uniqueOptionTwo_Array).each(function(index, value){
                if(value != ''){
                    if(value == selected_option_two){
                        optionTwoOptiones += "<option value='"+value+"' selected>"+value+"</option>";
                    }else{
                        optionTwoOptiones += "<option value='"+value+"'>"+value+"</option>";
                    }
                    
                }
            });
            $this.parents(".block__cart-item-product-options-list").find(".js-cart-item-product-option-2").html(optionTwoOptiones);
        }
        
        if(optionThree_Array.length > 0){
            var uniqueOptionThree_Array = [...new Set(optionThree_Array)];
            let optionThreeOptiones;
            $(uniqueOptionThree_Array).each(function(index, value){
                if(value != ''){
                    if(value == selected_option_three){
                        optionThreeOptiones += "<option value='"+value+"' selected>"+value+"</option>";
                    }else{
                        optionThreeOptiones += "<option value='"+value+"'>"+value+"</option>";
                    }
                }
            });
            $this.parents(".block__cart-item-product-options-list").find(".js-cart-item-product-option-3").html(optionThreeOptiones);
        }

        let FinalselectedValue = [];
        $this.parents(".block__cart-item-product-options-list").find(".js-cart-item-product-option").each(function(){
            FinalselectedValue.push($(this).val());
        });

        let arrayJoin = FinalselectedValue.join(' / ');
        let newid = $this.parents(".block__cart-item-product-options-list").find(".variant_select option[data-value='"+arrayJoin+"']").attr("data-id");
        
        CartItemUpdate(id, newid, qty);
    }

    function CartItemUpdate(id, newid, qty){
        $(".js-cart-drawer-item-btn-qty, .js-cart-drawer-item-quantity-input").attr("disabled", true);
        $(".js-cart-drawer-footer-cart-btn-submit").addClass("js-cart-update-runing").attr("disabled", true);
        
        $.ajax({
            url: '/cart/change.js',
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify({
                id: id,
                quantity: 0
            }),
            success: function(respones) {
                $.ajax({
                    url: '/cart/add.js',
                    type: 'POST',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: JSON.stringify({
                        id: newid,
                        quantity: qty
                    }),
                    success: function(respones) {
                        CartDrawerRefresh();
                    }
                });
            }
        });
    }

    $(document).on("click",".js-product-form-add-btn",function(event){
        event.preventDefault();
        let $this = $(this);

        let FormSerialize = $this.parents("form").serialize();
        $this.addClass("loading").attr("disabled",true);
        $.ajax({
            url: '/cart/add.js',
            type: 'POST',
            dataType: 'json',
            data: FormSerialize,
            success:function(data) {
                CartDrawerRefresh();
            },
            complete: function(){
                $this.removeClass("loading").attr("disabled",false);
                $(".js-cart-drawer-overlay, .js-cart-drawer-section").addClass("active");
            },
            error: function (error) {
                $this.removeClass("loading").attr("disabled",false);
            }
        });
    });

    function CartItemChange(id, qty){
        $(".js-cart-drawer-item-btn-qty, .js-cart-drawer-item-quantity-input").attr("disabled", true);
        $(".js-cart-drawer-footer-cart-btn-submit").addClass("js-cart-update-runing").attr("disabled", true);
        $.ajax({
            url: '/cart/change.js',
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify({
                id: id,
                quantity: qty
            }),
            success: function(respones) {
              CartDrawerRefresh()
            }
          });
    }

    function CartDrawerRefresh() {
        $.ajax({
            url: '/?section_id=new-cart-drawer',
            type: 'GET',
            dataType: 'html',
            success: function (carthtml) {
                $(".js-cart-drawer-section").html($(carthtml).find(".js-cart-drawer-section").html());
                $.getJSON('/cart.js',function(cart){
                    $(".js-cart-item-count").text(cart.item_count);
                });
            },
            complete: function (){
                loadJsAfterCartDrawer();
            }
        });
    }

    function loadJsAfterCartDrawer(){
        $(".js-cart-item-product-option").on("change",function(){
            let $this = $(this);
            $(".js-cart-item-product-option").prop('disabled', 'disabled');
            cartItemOptionUpdate($this);
        });
        $(".js-cart-drawer-item-quantity-input").on("change",function(){
            let $this = $(this);
            let parentElement = $this.parents(".js-cart-drawer-item-box");
            let id = parentElement.attr("js-data-variant-id");
            let qty = $this.val();
            CartItemChange(id, qty)   
        });
    }
});